export const referenceHighlightTypes = {
    highlight: "Destacados por defecto",
    discount: "Destacado con descuento"
};
